import { IValidationContextType } from './model';

export const initalState: IValidationContextType = {
  errors: {},
  reportError: () => {},
  clearError: () => {},
  getAllErrors: () => [],
  getAllErrorsWithFields: () => [],
  getLatestError: () => null,
  getErrorByField: () => null,
};
